// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("./TypeUtils.bs.js");
var StringUtils = require("../StringUtils.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function futureAddedValue(param_0) {
  return /* FutureAddedValue */{
          _0: param_0
        };
}

function toEnum(param) {
  if (param !== 0) {
    if (param !== 1) {
      return ;
    } else {
      return /* FOH */1;
    }
  } else {
    return /* BOH */0;
  }
}

function fromEnum(param) {
  if (typeof param === "number") {
    if (param !== 0) {
      return 1;
    } else {
      return 0;
    }
  } else {
    return 2;
  }
}

var include = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum,
      toEnum: toEnum
    });

function parseApiResponse(param) {
  if (typeof param === "string") {
    if (param === "FOH") {
      return /* FOH */1;
    } else {
      return /* BOH */0;
    }
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

function fromString(str) {
  var match = Relude_String.toLowerCase(str);
  switch (match) {
    case "boh" :
        return /* BOH */0;
    case "foh" :
        return /* FOH */1;
    default:
      return /* FutureAddedValue */{
              _0: str
            };
  }
}

function toString(str) {
  if (typeof str === "number") {
    if (str !== 0) {
      return "FOH";
    } else {
      return "BOH";
    }
  } else {
    return str._0;
  }
}

var decode = Curry._1(Json.Decode.variantFromString, (function (param) {
        return Relude_Globals.$great$great(fromString, Relude_Option.pure, param);
      }));

function encode(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(toString, StringUtils.toUpperCase, param);
              }), (function (prim) {
                return prim;
              }), param);
}

var bOH = /* BOH */0;

var fOH = /* FOH */1;

var fromEnum$1 = include.fromEnum;

var toEnum$1 = include.toEnum;

var eq = include.eq;

var compare = include.compare;

var Ord = include.Ord;

var compareWithConversion = include.compareWithConversion;

var compareReversed = include.compareReversed;

var OrdReversed = include.OrdReversed;

var compareAsInt = include.compareAsInt;

var min = include.min;

var max = include.max;

var lessThan = include.lessThan;

var lt = include.lt;

var lessThanOrEq = include.lessThanOrEq;

var lte = include.lte;

var greaterThan = include.greaterThan;

var gt = include.gt;

var greaterThanOrEq = include.greaterThanOrEq;

var gte = include.gte;

var clamp = include.clamp;

var between = include.between;

var OrdRingExtensions = include.OrdRingExtensions;

var OrdNamed = include.OrdNamed;

var OrdBy = include.OrdBy;

var $$Set = include.$$Set;

var SetWithNone = include.SetWithNone;

var $$Map = include.$$Map;

var list = include.list;

var array = include.array;

var set = include.set;

var setWithNone = include.setWithNone;

var cardinality = include.cardinality;

var top = include.top;

var bottom = include.bottom;

var succ = include.succ;

var pred = include.pred;

exports.bOH = bOH;
exports.fOH = fOH;
exports.futureAddedValue = futureAddedValue;
exports.fromEnum = fromEnum$1;
exports.toEnum = toEnum$1;
exports.eq = eq;
exports.compare = compare;
exports.Ord = Ord;
exports.compareWithConversion = compareWithConversion;
exports.compareReversed = compareReversed;
exports.OrdReversed = OrdReversed;
exports.compareAsInt = compareAsInt;
exports.min = min;
exports.max = max;
exports.lessThan = lessThan;
exports.lt = lt;
exports.lessThanOrEq = lessThanOrEq;
exports.lte = lte;
exports.greaterThan = greaterThan;
exports.gt = gt;
exports.greaterThanOrEq = greaterThanOrEq;
exports.gte = gte;
exports.clamp = clamp;
exports.between = between;
exports.OrdRingExtensions = OrdRingExtensions;
exports.OrdNamed = OrdNamed;
exports.OrdBy = OrdBy;
exports.$$Set = $$Set;
exports.SetWithNone = SetWithNone;
exports.$$Map = $$Map;
exports.list = list;
exports.array = array;
exports.set = set;
exports.setWithNone = setWithNone;
exports.cardinality = cardinality;
exports.top = top;
exports.bottom = bottom;
exports.succ = succ;
exports.pred = pred;
exports.parseApiResponse = parseApiResponse;
exports.fromString = fromString;
exports.toString = toString;
exports.decode = decode;
exports.encode = encode;
/* include Not a pure module */
